import { render, staticRenderFns } from "./Register02.vue?vue&type=template&id=60cc7878&scoped=true&"
import script from "./Register02.vue?vue&type=script&lang=js&"
export * from "./Register02.vue?vue&type=script&lang=js&"
import style0 from "./Register02.vue?vue&type=style&index=0&id=60cc7878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc7878",
  null
  
)

export default component.exports